module.exports = __webpack_public_path__ + "img/donation.80702ec3.png";